import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useEffect, useRef } from "react";
import { WITH_BLIP } from "./PaymentMethod";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  Heading,
  Link,
} from "@ogt/ui";

import { URLS } from "src/config/urls";

export default function PaymentWithBlip() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 40;
  // Reset specific fields if the selected compensation is not WITH_BLIP
  useEffect(() => {
    if (formData.paymentmethod === WITH_BLIP) {
      setFormData((prev) => ({
        ...prev,
        cardnumber: "",
        phonenumberapp: "",
      }));
    }
  }, [formData.compensation, setFormData]);

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values, { setSubmitting, setErrors }) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/ersattning-for");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          ticketnumber: Yup.string()
            .required("Vänligen fyll i ditt biljett-ID")
            .min(7, "Biljett-ID måste innehålla 7 tecken"),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading progress={progress} headingRef={h2Ref} focusable>
                  Jag blippade mitt bankkort ombord
                </Heading>

                <p>
                  För att gå vidare behöver vi biljettens ID.{" "}
                  <Link underline="always" className="inline!" target="_blank" rel="noreferrer" href={URLS.getReceipt}>
                    Ta reda på biljettens ID här.
                  </Link>
                </p>
                <p>
                  Har det gått mer än sju dagar sedan du reste och vill
                  reklamera en biljett som du betalat genom att blippa ditt
                  betalkort kontaktar du kundservice.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="ticketnumber"
                  label={
                    <>
                      Biljett-ID <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  autocomplete={"off"}
                  moreinfo="7 tecken"
                  maxLength={7}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
